import { useInfoPanelDetails } from 'gcs-common/clients/api/entities/channels/channel-api';
import ProfileImage, { ProfileImageSize } from 'gcs-common/components/InfoPanel/ListComponents/ProfileImage';
import { LastOnlineStatusBadge } from 'gcs-common/components/LastOnlineStatusBadge/LastOnlineStatusBadge';
import FeatureFlagProtectedRoute from 'gcs-common/components/ProtectedRoutes/FeatureFlagProtectedRoute';
import FEATURE_FLAGS from 'gcs-common/helper/featureFlagsHelper';
import { getIsAgent } from 'gcs-common/slices/currentUser/currentUserSelectors';
import type { components } from 'gcs-common/types/openapi';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

interface MemberHeaderProps {
  selectedUserId: string;
  name: string;
  image?: string;
  selectedUserIsAgent: boolean;
  userStatus: components['schemas']['ChatUserStatusDTO'];
}

const MemberHeader = (props: MemberHeaderProps) => {
  const { selectedUserId, name = '', image = '', selectedUserIsAgent, userStatus } = props;
  const { routeChannelId: selectedChannelId = '' } = useParams<{ routeChannelId: string }>();

  const currentUserIsAgent = useSelector(getIsAgent);

  const { data: infoPanelData } = useInfoPanelDetails(selectedChannelId);
  const selectedUser = infoPanelData?.users?.find((u) => u.id === selectedUserId);

  const channelCompanyName = selectedUser?.customerFriendlyName;
  const channelCustomerNumber = selectedUser?.customerNo;

  return (
    <div className="flex flex-col items-center gap-4 p-4">
      <div className="self-center">
        <ProfileImage imageUrl={image} size={ProfileImageSize.LARGE} isRounded={true} />
      </div>

      <div className="justify-items-center">
        <div className="text-xl">{name}</div>
        {!selectedUserIsAgent && currentUserIsAgent && channelCompanyName && channelCustomerNumber && (
          <div className="text-neutral-11 text-sm"> {`${channelCompanyName} ∙ ${channelCustomerNumber}`} </div>
        )}
      </div>
      <FeatureFlagProtectedRoute enabledFlag={FEATURE_FLAGS.LAST_ONLINE_BADGE_ENABLED}>
        {!selectedUserIsAgent && currentUserIsAgent && <LastOnlineStatusBadge userStatus={userStatus} />}
      </FeatureFlagProtectedRoute>
    </div>
  );
};

export default MemberHeader;
